import LocationTable from "@/app/app-shared/locations/table";

export default function LocationListingPage() {
  return (
    <div className="mt-4" >
      <LocationTable />
    </div>
  );
}
